// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetSpaClaim = () => ({
    type: actions.RESET_TCSM_SPA_CLAIM_DETAILS
});



// WEBPACK FOOTER //
// ./src/tcsm/spa-details/action-creators/reset-spa-claim.js